module.exports = __webpack_public_path__ + "static/media/1.fb1ab786.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/shirt/1.png
// module id = 61
// module chunks = 0